import * as z from 'zod';
import { ContractSuretyType, contractDamageSchema, contractHazardSchema, usStateOrTerritorySchema } from '../../../../enums.mjs';
import { naicsCodeId, city } from '../../../opaque.mjs';
import { currencySchema, safeNumberSchema } from '../../../utils.mjs';
import { Underwriting as Underwriting$1 } from './contract-surety-quote.types.mixins.mjs';

var Underwriting;
(function (Underwriting) {
    Underwriting.schema = z.object({
        contractSuretyType: z.literal(ContractSuretyType.final),
        bond: Underwriting$1.Bond.baseSchema,
        project: Underwriting$1.Project.schema,
    });
})(Underwriting || (Underwriting = {}));
var Bond;
(function (Bond) {
    Bond.schema = z.object({
        contractAmount: currencySchema,
        completionBond: z.boolean().nullish(),
    });
})(Bond || (Bond = {}));
var Project;
(function (Project) {
    Project.schema = z.object({
        name: z.string().min(1),
        projectNumber: z.string().nullish(),
        description: z.string().nullable(),
        address: z
            .object({
            city: city.nullish(),
            state: usStateOrTerritorySchema.nullish(),
        })
            .nullish(),
        scopeOfWork: z.array(naicsCodeId),
        monthsToComplete: safeNumberSchema.min(1).nullish(),
        contractWarrantyMonths: safeNumberSchema.nonnegative().nullish(),
        contractHazards: z.array(contractHazardSchema).default([]),
        contractDamages: z.array(contractDamageSchema).default([]),
    });
})(Project || (Project = {}));
var Data;
(function (Data) {
    Data.schema = z.object({
        suretyType: z.literal("contract"),
        contractSuretyType: z.literal(ContractSuretyType.final),
        bond: Bond.schema,
        project: Project.schema,
    });
})(Data || (Data = {}));
var Details;
(function (Details) {
    Details.schema = z.object({
        contractSuretyType: z.literal(ContractSuretyType.final),
        contractAmount: currencySchema,
        underwriting: Underwriting.schema,
    });
})(Details || (Details = {}));

export { Bond, Data, Details, Project, Underwriting };
